import React from 'react';

interface Props {
  connected?: boolean;
}

const SlackSettingsSkeleton: React.FC<Props> = ({ connected = false }) => {
  return (
    <div className="px-8 py-12 flex-1">
      {connected ? (
        <div className="space-y-6">
          <div className="flex items-center justify-between px-3 py-2 rounded-xl border border-green-800/20 bg-green-900/10">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-green-600 animate-pulse" />
              <div className="h-4 w-48 bg-gray-300/30 dark:bg-gray-700/50 rounded animate-pulse" />
            </div>
            <div className="h-8 w-24 bg-gray-300/30 dark:bg-gray-700/50 rounded-lg animate-pulse" />
          </div>
          <div className="rounded-xl border border-gray-200 dark:border-gray-700 p-4 bg-white/60 dark:bg-gray-800/50">
            <div className="space-y-3">
              <div className="h-4 w-3/4 bg-gray-300/30 dark:bg-gray-700/50 rounded animate-pulse" />
              <div className="grid grid-cols-1 gap-2">
                <div className="h-5 w-full bg-gray-300/30 dark:bg-gray-700/50 rounded animate-pulse" />
                <div className="h-5 w-2/3 bg-gray-300/30 dark:bg-gray-700/50 rounded animate-pulse" />
                <div className="h-5 w-1/2 bg-gray-300/30 dark:bg-gray-700/50 rounded animate-pulse" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 p-4 bg-white dark:bg-gray-800 min-h-[130px]">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded bg-gray-300/30 dark:bg-gray-700/50 animate-pulse" />
            <div className="flex-1 space-y-2">
              <div className="h-5 w-64 bg-gray-300/30 dark:bg-gray-700/50 rounded animate-pulse" />
              <div className="h-4 w-3/5 bg-gray-300/30 dark:bg-gray-700/50 rounded animate-pulse" />
            </div>
          </div>
          <div className="mt-4 h-6 w-64 bg-gray-300/30 dark:bg-gray-700/50 rounded animate-pulse" />
        </div>
      )}
    </div>
  );
};

export default SlackSettingsSkeleton;